module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/84.703d8c31.png";